import type { TemperatureTier } from '@/scopes/content/domain/weather'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import { WeatherGraphBar } from '@/scopes/content/components/Weather/WeatherGraphBar'
import styles from './SummerTemperatureGraphBar.module.css'

const tierClass: Record<TemperatureTier, string> = {
  1: styles.tierHot,
  2: styles.tierWarm,
  3: styles.tierCool,
}

interface SummerTemperatureGraphBarProps {
  maxTemp: number
  minTemp: number
  maxTempRatio: number
  tier: TemperatureTier
}

export function SummerTemperatureGraphBar({ maxTemp, minTemp, maxTempRatio, tier }: SummerTemperatureGraphBarProps) {
  const intl = useIntl()

  return (
    <WeatherGraphBar
      className={tierClass[tier]}
      ratio={maxTempRatio}
    >
      <div className={styles.tempGroup}>
        <Typography variant="body-l-bold-tight">
          {maxTemp}
          °
        </Typography>
        <Typography variant="body-s-regular-tight">{intl.formatMessage({ id: 'content_weather_label_max' })}</Typography>
      </div>
      <div className={styles.tempGroup}>
        <Typography variant="body-l-bold-tight">
          {minTemp}
          °
        </Typography>
        <Typography variant="body-s-regular-tight">{intl.formatMessage({ id: 'content_weather_label_min' })}</Typography>
      </div>
    </WeatherGraphBar>
  )
}
